<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    rate: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    // console.log(props);
    const myEcharts = ref(null);
    const chart = new InitChart(props, myEcharts);
    onMounted(() => {
      // console.log(props)
      chart.init(props.rate,props.title);
      
    });
    return {
      myEcharts,
    };
  },
};
class InitChart {
  constructor(props, myEcharts) {
    this.props = props;
    this.myEcharts = myEcharts;
    this.state = {
      chart: null,
    };
  }

  init(rate,title) {
    this.state.chart && this.destory();
    this.state.chart = echarts.init(this.myEcharts.value);

   // const rate = '65%'
   const radius = 120;
   const endPointRadius = [(radius / 2 - 2) + '%', radius / 2 + '%']
   const diffDegree = 360 / 270

    this.state.chart.setOption({
         title: [
        {
            text: rate,
            textStyle: {
                fontSize: 30,
                // color: '#2edadf',
				color: '#fff',
                fontWeight:600,
            },
            x: 'center',
            y: 'center',
        },
        {
            text: title,
            textStyle: {
                fontSize: 28,
                color: '#fff',
               //  fontWeight:600,
            },
            x: 'center',
            y: '86%',
        }
    ],
    angleAxis: {
        show: false,
        max: (100 * 360) / 270, //-45度到225度，二者偏移值是270度除360度
        type: 'value',
        startAngle: 225, //极坐标初始角度
        splitLine: {
            show: false,
        },
    },
    barMaxWidth: 15, //圆环宽度
    radiusAxis: {
        show: false,
        type: 'category',
    },
    //圆环位置和大小
    polar: {
        center: ['50%', '50%'],
        radius: radius + '%',
    },
    series: [
        {
           name: '上层绿环',
           type: 'bar',
            data: [
                {
                    //上层圆环，显示数据
                    value: parseInt(rate.slice(0, -1)),
                    name: 'sdfasdf',
                    itemStyle: {
                      color: { // 完成的圆环的颜色
                        colorStops: [{
                            offset: 0,
                            color: '#082E47' // 0% 处的颜色
                        }, {
                            offset: 0.5,
                            color: '#2edadf' // 100% 处的颜色
                        }, {
                            offset: 0.8,
                            color: '#2edadf' // 100% 处的颜色
                        }, {
                            offset: 1,
                            color: '#082E47' // 100% 处的颜色
                        }]
                    },
                    },
                },
            ],
            barGap: '-100%', //柱间距离,上下两层圆环重合
            coordinateSystem: 'polar',
            roundCap: true, //顶端圆角从 v4.5.0 开始支持
            z: 2,
        },
        
        // 带空心的小圆点
        {
          type: 'pie',
          radius: endPointRadius,
          zlevel: 10,
          silent: true,
          startAngle: 225,
          data: [
            {
              name: '',
              value: ( parseInt(rate.slice(0, -1)) / 100 ).toFixed(2),
              label: {
                show: false,
              },
              labelLine: {
                show: false,
              },
              itemStyle: {
                color: 'rgba(0,0,0,0)',
              },
            },
    
            // 画中间的图标
            {
              name: '',
              value: 0,
              label: {
                position: 'inside',
                backgroundColor: '#fff',
                borderRadius: 16,
                padding: 8, // 可以控制圆的大小
                borderWidth: 4,
                borderColor: 'rgba(255, 255, 255, 1)',
                shadowOffsetX: 0, // 折线的X偏移---外发光
	            shadowOffsetY: 0,// 折线的Y偏移---外发光
	            shadowBlur: 8,  // 折线模糊---外发光
	            shadowColor: "rgba(255, 255, 255, .99)"
              },
            },
            {
              name: '',
              value: diffDegree -  ( parseInt(rate.slice(0, -1)) / 100 ).toFixed(2),
              label: {
                show: false,
              },
              labelLine: {
                show: false,
              },
              itemStyle: {
                color: 'rgba(255,255,255,0)',
              },
            },
          ],
        },
    ],
         
    });
    window.addEventListener("resize", () => {
      this.state.chart.resize();
    });
  }

  destory() {
    this.state.chart.dispose();
    window.removeEventListener("resize", () => {
      console.log("事件移除");
    });
  }
}
</script>
<style lang="less"></style>
